<app-loading *ngIf="contentReady"></app-loading>

<section class="bb-page" *ngIf="!contentReady">
  <div class="bb-page-shell">

    <!-- Header & Actions -->
    <div class="bb-page-header">
      <div class="bb-page-title-block">
        <span class="bb-eyebrow">{{ 'Brand Management' | transloco }}</span>
        <h2 class="bb-page-title">{{ 'Brand Management' | transloco }}</h2>
      </div>

      <div class="bb-header-actions">
        <button routerLink="/createbrand" class="bb-btn bb-btn-primary bb-btn-wide">
          {{ "createbrand" | transloco }}
        </button>
      </div>
    </div>

    <!-- Brands Table -->
    <div class="bb-table-card bb-p-16">
      <div class="bb-table-scroll">
        <table class="bb-table table">
          <thead>
            <tr>
                            <th>{{ "brand_logo" | transloco }}</th>
              <th>{{ "Name" | transloco }}</th>
              <th>{{ "brandname_ar" | transloco }}</th>
              <th>{{ "brand_description_en" | transloco }}</th>
              <th>{{ "brand_description_ar" | transloco }}</th>

              <th class="bb-actions-th">{{ 'Actions' | transloco }}</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let element of dataSource.data">

              <!-- Brand Logo -->
              <td>
                <div class="bb-product-img-box">
                  <img [src]="fixurl(element.brand_logo)" [alt]="'logo' | transloco" (error)="onBrandImageError($event)" />
                </div>
              </td>
              <!-- Brand Name EN -->
              <td>
                <strong class="bb-text-navy">{{ element.brandname_en || '—' }}</strong>
              </td>

              <!-- Brand Name AR -->
              <td>{{ element.brandname_ar || '—' }}</td>

              <!-- Description EN (Expandable) -->
              <td>
                <div class="bb-text-stack">
                  <span>
                    {{ element.showMoreEn ? element.brand_description_en : (element.brand_description_en | slice:0:80) }}
                  </span>

                  <span *ngIf="element.brand_description_en?.length > 80" class="bb-inline-flex bb-items-center bb-gap-4">
                    <span class="bb-text-muted">...</span>
                    <button
                      class="bb-link-action bb-p-0"
                      type="button"
                      (click)="element.showMoreEn = !element.showMoreEn; $event.stopPropagation()"
                    >
                      {{ element.showMoreEn ? 'Show Less' : 'Show More' }}
                    </button>
                  </span>
                </div>
              </td>

              <!-- Description AR (Expandable) -->
              <td>
                <div class="bb-text-stack" [attr.dir]="'rtl'">
                  <span>
                    {{ element.showMoreAr ? element.brand_description_ar : (element.brand_description_ar | slice:0:80) }}
                  </span>

                  <span *ngIf="element.brand_description_ar?.length > 80" class="bb-inline-flex bb-items-center bb-gap-4">
                    <span class="bb-text-muted">...</span>
                    <button
                      class="bb-link-action bb-p-0"
                      type="button"
                      (click)="element.showMoreAr = !element.showMoreAr; $event.stopPropagation()"
                    >
                      {{ element.showMoreAr ? 'عرض أقل' : 'عرض المزيد' }}
                    </button>
                  </span>
                </div>
              </td>


              <!-- Actions Dropdown -->
              <td class="bb-actions-td">
                <div class="bb-action-dropdown dropdown">
                  <button
                    class="bb-icon-btn"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    title="{{ 'Actions' | transloco }}"
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                      <circle cx="12" cy="5" r="2" />
                      <circle cx="12" cy="12" r="2" />
                      <circle cx="12" cy="19" r="2" />
                    </svg>
                  </button>

                  <ul class="bb-dropdown-menu dropdown-menu dropdown-menu-end">
                    <li>
                      <a class="bb-dropdown-item dropdown-item" (click)="openAddImage(element.id); $event.stopPropagation()">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <rect x="3" y="3" width="18" height="18" rx="2" />
                          <circle cx="8.5" cy="8.5" r="1.5" />
                          <path d="M21 15l-5-5L5 21" />
                        </svg>
                        {{ "AddImage" | transloco }}
                      </a>
                    </li>

                    <li>
                      <a class="bb-dropdown-item dropdown-item" (click)="edit(element); $event.stopPropagation()">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                        </svg>
                        {{ "Edit" | transloco }}
                      </a>
                    </li>

                    <li>
                      <hr class="dropdown-divider">
                    </li>

                    <li>
                      <a class="bb-dropdown-item dropdown-item text-danger" (click)="deleteitem(element.id); $event.stopPropagation()">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" />
                        </svg>
                        {{ "Delete" | transloco }}
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Paginator -->
      <mat-paginator
        [length]="stockTotal"
        [pageSize]="10"
        (page)="onPaginateChange($event)"
        class="bb-paginator"
      >
      </mat-paginator>

      <!-- No Data State -->
      <div *ngIf="noData" class="bb-empty-state">
        <app-nodata></app-nodata>
      </div>
    </div>

  </div>
</section>

<!-- Add Image Popup Modal -->
<div *ngIf="addImage" class="bb-modal-backdrop" (click)="close()">
  <div class="bb-modal-card bb-modal-sm" (click)="$event.stopPropagation()">

    <!-- Modal Header -->
    <div class="bb-modal-header">
      <h4>{{ 'Upload brand logo' | transloco }}</h4>

      <button class="bb-modal-close" (click)="close()" type="button">
        ×
      </button>
    </div>

    <!-- Upload Card -->
    <div class="bb-upload-card bb-w-100" (click)="fileInput.click()">
      <input #fileInput type="file" hidden accept="image/*" (change)="onImageSelected($event)" />

      <div class="bb-upload-area">
        <div *ngIf="!imagePreview" class="bb-upload-placeholder">
          <span class="bb-upload-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="17,8 12,3 7,8" />
              <line x1="12" y1="3" x2="12" y2="15" />
            </svg>
          </span>

          <p class="bb-upload-title">{{ 'Upload brand logo' | transloco }}</p>
          <small class="bb-upload-sub">{{ 'PNG / JPG • Max 2MB' | transloco }}</small>
        </div>

        <div *ngIf="imagePreview" class="bb-preview-container">
          <img [src]="imagePreview" class="bb-preview-img" />

          <button
            type="button"
            class="bb-btn bb-btn-secondary bb-btn-sm"
            (click)="fileInput.click(); $event.stopPropagation()"
          >
            {{ 'Change image' | transloco }}
          </button>
        </div>
      </div>
    </div>

    <!-- Submit -->
    <div class="bb-modal-actions">
      <button class="bb-btn bb-btn-primary" type="button" (click)="submitImage()" [disabled]="!selectedFile">
        {{ "Submit" | transloco }}
      </button>
    </div>

  </div>
</div>
